<template>
	<div class="q-ma-sm relative-position">
		<div class="row q-col-gutter-lg text-left">
			<div class="col-xs-6 col-sm-3" v-if="$hasRanking()">
				<q-card>
					<q-card-section>
						<div class="row cursor-pointer" @click="show_all_ranking = true">
							<div class="col-12">
								<q-icon name="fas fa-list-ol" color="brown-4" size="lg" />
							</div>

							<div class="col-12 q-mt-md text-caption text-grey-6 text-lowercase">
								{{ $t('ranking') }}
							</div>

							<div class="col-12 text-weight-bold text-brown-4">
								{{ position_ranking ? position_ranking : position_ranking_general }}º
								{{ $t('place') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="$hasScore()">
				<q-card>
					<q-card-section>
						<div class="row cursor-pointer" @click="show_statement = true">
							<div class="col-12">
								<q-icon name="fal fa-trophy" color="red-5" size="lg" />
							</div>

							<div class="col-12 q-mt-md text-caption text-grey-6 text-lowercase">
								{{ $t('pontuation') }}
							</div>

							<div class="col-12">
								<span class="text-weight-bold text-red-5 q-mr-xs"
									>{{ score.toFixed(0) }} {{ $t('point', { count: score }) }}</span
								>
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="hasBadges">
				<q-card>
					<q-card-section>
						<div class="row cursor-pointer" @click="show_all_badges = true">
							<div class="col-12">
								<q-icon name="fal fa-medal" color="deep-purple-5" size="lg" />
							</div>

							<div class="col-12 q-mt-md text-caption text-grey-6 text-lowercase">
								{{ $t('badges') }}
							</div>

							<div class="col-12 text-weight-bold text-deep-purple-5">
								{{ qty_user_badges }} {{ $t('badge', { count: qty_user_badges }) }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3">
				<q-card>
					<q-card-section>
						<div class="row cursor-pointer" @click="showAllCertificates()">
							<div class="col-12">
								<q-icon name="fal fa-file-certificate" color="indigo-5" size="lg" />
							</div>

							<div class="col-12 q-mt-md text-caption text-grey-6 text-lowercase">
								{{ $t('certificates') }}
							</div>

							<div class="col-12 text-weight-bold text-indigo-5">
								{{ qty_group_training_user_results }}
								{{ $t('certificate', { count: qty_group_training_user_results }) }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>
		</div>

		<div class="row q-col-gutter-lg q-mt-lg">
			<div class="col-12 text-h6 text-weight-bold" :class="isMobile ? 'text-white' : ''">
				{{ $t('progress') }}
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_courses">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('courses')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'courses')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="online_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ online_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ online_certified }} {{ $t('of') }} {{ online_published }} {{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_trails">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('trails')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'trails')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="trails_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ trails_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ trails_certified }} {{ $t('of') }} {{ trails_published }} {{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_presential">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('presentials')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'presentials')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="presentials_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ presentials_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ presentials_certified }} {{ $t('of') }} {{ presentials_published }}
								{{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_live_classes">
				<q-card
					style="min-height: 200px"
					class="cursor-pointer"
					@click="redirectTo('live_classes')"
				>
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'live_classes')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="live_classes_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ live_classes_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ live_classes_certified }} {{ $t('of') }} {{ live_classes_published }}
								{{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_webcasts">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('webinars')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'webinars')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="webcasts_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ webcasts_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ webcasts_certified }} {{ $t('of') }} {{ webcasts_published }}
								{{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_podcasts">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('podcasts')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'podcasts')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="podcasts_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ podcasts_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ podcasts_certified }} {{ $t('of') }} {{ podcasts_published }}
								{{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>

			<div class="col-xs-6 col-sm-3" v-if="clientModules.has_drills">
				<q-card style="min-height: 200px" class="cursor-pointer" @click="redirectTo('drills')">
					<q-card-section>
						<div class="row q-col-gutter-md text-center">
							<div class="col-12" style="min-height: 60px">
								{{ $t(progress_title.find((t) => t.to === 'drills')?.text) }}
							</div>

							<div class="col-12">
								<q-circular-progress
									show-value
									class="text-primary"
									:value="drills_percentage_completed"
									:size="isMobile ? `4rem` : `8rem`"
									color="primary"
									track-color="grey-3"
								>
									{{ drills_percentage_completed }}%
								</q-circular-progress>
							</div>

							<div class="col-12 text-lowercase">
								{{ drills_certified }} {{ $t('of') }} {{ drills_published }}
								{{ $t('finished') }}
							</div>
						</div>
					</q-card-section>
				</q-card>
			</div>
		</div>

		<div class="row q-col-gutter-lg q-mt-lg">
			<div class="col-sm-6 col-xs-12" v-if="hasBadges">
				<div class="text-h6 text-weight-bold q-mb-md" :class="isMobile ? 'text-white' : ''">
					{{ $t('badges') }}
				</div>

				<q-card
					class="position-relative q-pb-xl"
					:class="isMobile ? 'bg-grey-9 cards-mobile' : 'cards-desktop'"
				>
					<q-card-section>
						<div class="row q-col-gutter-xs">
							<div class="col-sm-2 col-xs-3" v-for="(badge, index) in badges" :key="index">
								<div class="q-img" :class="badge.earned_date ? '' : 'disabled-badge'">
									<div class="img">
										<img
											class="full-width"
											:src="badgeImage(badge.badge_images)"
											:alt="badge.badge_image_alt_texts"
										/>
										<q-tooltip>
											{{ badge.title }}<br />
											{{ badge.description }}<br />
											<span role="p">
												{{
													badge.earned_date
														? $t('you_got_this_badge_on')
														: $t('you_dont_have_this_badge_yet')
												}}
												{{ badge.earned_date ? ` ${$dateUtil.fDateTime(badge.earned_date)}` : '' }}
											</span>
										</q-tooltip>
									</div>
								</div>
							</div>
						</div>
					</q-card-section>

					<q-card-actions align="center" class="absolute-bottom">
						<q-separator class="" />

						<q-btn
							dense
							flat
							:label="$t('see_all_badges')"
							:color="isMobile ? 'white' : 'primary'"
							@click="show_all_badges = true"
						/>
					</q-card-actions>
				</q-card>
			</div>

			<!-- MOBILE -->
			<div v-if="isMobile && $hasRanking()" class="col-sm-6 col-xs-12">
				<div class="text-h6 text-weight-bold q-mb-md text-white">
					{{ $t('ranking') }}
				</div>

				<q-card class="position-relative big-cards bg-grey-9 text-white q-pb-xl">
					<q-card-section>
						<q-list dense style="font-size: 16px">
							<q-item
								clickable
								v-for="(ranking, index) in filteredRanking"
								:key="index"
								v-if="filteredRanking.length > 0"
							>
								<q-item-section side>
									{{ index + 1 }}
								</q-item-section>

								<q-item-section avatar>
									<q-avatar size="28px" color="primary" text-color="white">
										<q-img :src="getImage(ranking)">
											<template v-slot:error>
												<span class="absolute-full flex flex-center bg-primary text-white">
													{{ ranking.n?.charAt(0).toUpperCase() }}
												</span>
											</template>
										</q-img>
									</q-avatar>
								</q-item-section>

								<q-item-section>
									<q-item-label class="user-name">{{ removeUserEmail(ranking.n) }}</q-item-label>
								</q-item-section>

								<q-item-section side v-if="ranking.s">
									{{ getScore(ranking.s) }}
								</q-item-section>

								<q-item-section side v-else>
									{{ getScore(0) }}
								</q-item-section>
							</q-item>

							<q-item v-if="user_position" class="text-white">
								<q-item-section side>
									{{ user_position.pos + 1 }}
								</q-item-section>

								<q-item-section avatar>
									<q-avatar color="primary" text-color="white">
										<q-img :src="getImage(user_position)" style="height: 2.5rem">
											<template v-slot:error>
												<div class="absolute-full flex flex-center bg-primary text-white">
													{{ user_position.n?.charAt(0).toUpperCase() }}
												</div>
											</template>
										</q-img>
									</q-avatar>
								</q-item-section>

								<q-item-section>{{ user_position.n }}</q-item-section>

								<q-item-section side v-if="user_position.s">
									{{ getScore(user_position.s) }}
								</q-item-section>

								<q-item-section side v-else>
									{{ getScore(0) }}
								</q-item-section>
							</q-item>

							<q-item v-if="filteredRanking.length === 0" class="text-white">
								<q-item-section class="text-body1">
									{{
										$t(
											'your_ranking_position_will_be_available_after_you_complete_at_least_one_course'
										)
									}}
								</q-item-section>
							</q-item>
						</q-list>
					</q-card-section>

					<q-card-actions align="center" class="absolute-bottom">
						<q-separator class="q-mb-sm" />

						<q-btn
							dense
							flat
							:label="$t('see_the_full_ranking')"
							color="primary"
							@click="show_all_ranking = true"
						/>
					</q-card-actions>
				</q-card>
			</div>

			<!-- DESKTOP -->
			<div v-if="!isMobile && $hasRanking()" class="col-sm-6 col-xs-12">
				<div class="text-h6 text-weight-bold q-mb-md">
					{{ $t('ranking') }}
				</div>

				<q-card class="position-relative cards-desktop">
					<q-card-section>
						<q-list dense>
							<q-item
								clickable
								v-for="(ranking, index) in filteredRanking"
								:key="index"
								v-if="filteredRanking.length > 0"
								class="text-grey-9"
							>
								<q-item-section side style="width: 2.05rem">
									{{ index + 1 }}
								</q-item-section>

								<q-item-section avatar>
									<q-avatar color="primary" text-color="white">
										<q-img :src="getImage(ranking)" style="height: 2.5rem">
											<template v-slot:error>
												<div class="absolute-full flex flex-center bg-primary text-white">
													{{ ranking.n?.charAt(0).toUpperCase() }}
												</div>
											</template>
										</q-img>
									</q-avatar>
								</q-item-section>

								<q-item-section class="text-ranking">{{
									removeUserEmail(ranking.n)
								}}</q-item-section>

								<q-item-section side v-if="ranking.s">
									{{ getScore(ranking.s) }}
								</q-item-section>

								<q-item-section side v-else>
									{{ getScore(0) }}
								</q-item-section>
							</q-item>

							<q-item v-if="user_position" class="text-grey-9 q-mb-lg">
								<q-item-section side style="width: 2.05rem">
									{{ user_position.pos + 1 }}
								</q-item-section>

								<q-item-section avatar>
									<q-avatar color="primary" text-color="white">
										<q-img :src="getImage(user_position)" style="height: 2.5rem">
											<template v-slot:error>
												<div class="absolute-full flex flex-center bg-primary text-white">
													{{ user_position.n?.charAt(0).toUpperCase() }}
												</div>
											</template>
										</q-img>
									</q-avatar>
								</q-item-section>

								<q-item-section class="text-ranking">{{
									removeUserEmail(user_position.n)
								}}</q-item-section>

								<q-item-section side v-if="user_position.s">
									{{ getScore(user_position.s) }}
								</q-item-section>

								<q-item-section side v-else>
									{{ getScore(0) }}
								</q-item-section>
							</q-item>
							<q-item v-if="filteredRanking.length === 0" class="text-grey-9">
								<q-item-section class="text-body1">
									{{
										$t(
											'your_ranking_position_will_be_available_after_you_complete_at_least_one_course'
										)
									}}
								</q-item-section>
							</q-item>
						</q-list>
					</q-card-section>

					<q-card-actions align="center" class="absolute-bottom">
						<q-separator class="q-mb-sm" />

						<q-btn
							dense
							flat
							:label="$t('see_the_full_ranking')"
							color="primary"
							@click="show_all_ranking = true"
						/>
					</q-card-actions>
				</q-card>
			</div>

			<div class="col-sm-6 col-xs-12">
				<div
					class="col-12 text-h6 text-weight-bold q-mb-md"
					:class="isMobile ? 'text-white' : 'text-black'"
				>
					{{ $t('certificates') }}
				</div>

				<q-card
					v-if="filteredCertificates.length > 0"
					class="position-relative q-pb-xl"
					:class="isMobile ? 'bg-grey-9 cards-mobile' : 'cards-desktop'"
				>
					<q-card-section>
						<div class="row q-col-gutter-md">
							<div
								class="col-sm-4 col-xs-6"
								v-for="(certificate, index) in filteredCertificates"
								:key="index"
							>
								<q-img :src="certificateImage(certificate)">
									<q-tooltip>
										{{ certificate.title }}<br />
										{{ $dateUtil.fDateTime(certificate.result_date) }}
									</q-tooltip>
								</q-img>
							</div>
						</div>
					</q-card-section>

					<q-card-actions align="center" class="absolute-bottom">
						<q-separator class="q-mb-sm" />

						<q-btn
							dense
							flat
							:label="$t('see_all_certificates')"
							:color="isMobile ? 'white' : 'primary'"
							@click="showAllCertificates()"
						/>
					</q-card-actions>
				</q-card>

				<q-card v-else :class="isMobile ? 'bg-grey-9' : ''" :dark="isMobile">
					<q-card-section>
						<q-item-label>{{ $t('no_certificates_available') }}</q-item-label>
					</q-card-section>
				</q-card>
			</div>
		</div>

		<q-dialog v-model="show_all_ranking" :maximized="isMobile">
			<ranking :ranking_list="ranking_list" />
		</q-dialog>

		<q-dialog v-model="show_all_badges" @hide="show_badge_details = false">
			<q-card style="min-width: 80vw; min-height: 50vh; max-height: 80vh">
				<q-toolbar>
					<q-btn
						round
						flat
						icon="fal fa-chevron-left"
						@click="show_badge_details = false"
						v-if="show_badge_details"
					/>

					<q-toolbar-title></q-toolbar-title>

					<q-btn flat round dense icon="fal fa-times" v-close-popup />
				</q-toolbar>

				<q-card-section v-if="!show_badge_details">
					<div class="row q-col-gutter-md">
						<div class="col-sm-2 col-xs-4" v-for="(badge, index) in badges" :key="index">
							<div class="row q-col-gutter-md text-weight-bold text-center">
								<div class="col-12" style="width: 80%; margin: 0 auto">
									<div
										class="q-img"
										:class="badge.earned_date ? 'cursor-pointer' : 'cursor-pointer disabled-badge'"
									>
										<div class="img">
											<img
												class="full-width"
												@click="showBadgeDetails(badge)"
												:src="badgeImage(badge.badge_images)"
												:alt="badge.badge_image_alt_texts"
											/>
											<q-tooltip>
												{{ badge.title }}<br />
												{{ badge.description }}<br />
												{{ badge.earned_date ? $dateUtil.fDateTime(badge.earned_date) : '' }}
											</q-tooltip>
										</div>
									</div>
								</div>

								<div class="col-12">
									<span class="text-grey-9">
										{{ badge.title }}
									</span>

									<span class="text-grey-6 text-body2" v-if="badge.earned_date">
										<br />
										{{ $dateUtil.fDate(badge.earned_date) }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</q-card-section>

				<q-card-section v-if="show_badge_details">
					<div class="row q-col-gutter-md">
						<div class="col-3">
							<div class="q-img" :class="selected_badge.earned_date ? '' : 'disabled-badge'">
								<div class="img">
									<img
										class="full-width"
										:src="badgeImage(selected_badge.badge_images)"
										:alt="selected_badge.badge_image_alt_texts"
									/>
								</div>
							</div>
						</div>

						<div class="col-9">
							<div class="row">
								<div class="col-12 text-weight-bold text-h5">
									{{ selected_badge.title }}
								</div>

								<div class="col-12 text-grey-6">
									{{ selected_badge.description }}
								</div>

								<div v-if="selected_badge.earned_date" class="col-12 text-grey-6 q-mt-md">
									<q-icon name="fal fa-clock" /> {{ $t('you_got_this_badge_on') }}
									{{ $dateUtil.fDate(selected_badge.earned_date) }}
								</div>
								<div v-else class="col-12 text-grey-6 q-mt-md">
									{{ $t('you_dont_have_this_badge_yet') }}
								</div>
								<!-- <div v-if="selected_badge.earned_date" class="row text-center" style="margin-top: auto;">
									<div class="col-12 network-icons">
										<template v-for="network in networks" :key="network.network">
											<ShareNetwork
											v-if="selected_badge"
											:network="network.network"
											:title="$t('badge_title_shared') + ' - ' + selected_badge.title"
											:url="selected_badge.shared_url"
											:description="selected_badge.description"
											:media="selected_badge.shared_url"
											>
											<q-btn flat round :icon="network.icon" color="black" v-if="network.network != 'twitter'" />
											<q-btn flat round :icon="`img:${icon_x_twitter}`" v-else/>
										</ShareNetwork>
									</template>
								</div>
							</div> -->
							</div>
						</div>
					</div>
				</q-card-section>
			</q-card>
		</q-dialog>

		<q-dialog v-model="show_all_certificates" :maximized="isMobile">
			<!-- :titleTrails="progress_title.find((t) => t.to === 'trails')?.text ?? ''" -->
			<!-- :hasTrails="clientModules.has_trails" -->
			<certificates
				:hasCourses="clientModules.has_courses"
				:hasPresentials="clientModules.has_presential"
				:hasLiveClasses="clientModules.has_live_classes"
				:hasWebinars="clientModules.has_webcasts"
				:titleTrails="progress_title.find((t) => t.to === 'trails')?.text ?? ''"
				:titleCourses="progress_title.find((t) => t.to === 'courses')?.text ?? ''"
				:titlePresentials="progress_title.find((t) => t.to === 'presentials')?.text ?? ''"
				:titleLiveClasses="progress_title.find((t) => t.to === 'live_classes')?.text ?? ''"
				:titleWebinars="progress_title.find((t) => t.to === 'webinars')?.text ?? ''"
				:hasTrails="clientModules.has_trails"
				@showCertificate="showCertificate"
			/>
		</q-dialog>

		<q-dialog v-model="show_certificate" :maximized="isMobile">
			<certificate :certificate="certificate" :course="course" />
		</q-dialog>

		<q-dialog v-model="show_statement" :maximized="isMobile">
			<!-- :hasTrails="clientModules.has_trails" -->
			<!-- :titleTrails="progress_title.find((t) => t.to === 'trails').text" -->
			<score-statement
				:hasCourses="clientModules.has_courses"
				:hasPresentials="clientModules.has_presential"
				:hasWebinars="clientModules.has_webcasts"
				:hasLiveClasses="clientModules.has_live_classes"
				:hasDrills="clientModules.has_drills"
				:titleCourses="progress_title.find((t) => t.to === 'courses')?.text ?? ''"
				:titlePresentials="progress_title.find((t) => t.to === 'presentials')?.text ?? ''"
				:titleWebinars="progress_title.find((t) => t.to === 'webinars')?.text ?? ''"
				:titleLiveClasses="progress_title.find((t) => t.to === 'live_classes')?.text ?? ''"
				:titleDrills="progress_title.find((t) => t.to === 'drills')?.text ?? ''"
			/>
		</q-dialog>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useI18n } from 'vue-i18n'
import { db } from 'src/boot/firebase'
import { getAuth } from 'firebase/auth'
import { doc, onSnapshot } from 'firebase/firestore'
import Ranking from 'components/user/Ranking'
import Certificate from 'components/utils/Certificate'
import Certificates from 'components/user/Certificates'
import ScoreStatement from 'components/user/ScoreStatement'
import IconXTwitter from 'src/assets/icon/x-twitter.svg'

export default {
	name: 'UserProgress',

	data() {
		return {
			badges: [],
			certificate: '',
			certificates: [],
			course: '',
			live_classes_certified: 0,
			live_classes_percentage_completed: 0,
			live_classes_published: 0,
			loading: false,
			online_certified: 0,
			online_percentage_completed: 0,
			online_published: 0,
			podcasts_certified: 0,
			podcasts_percentage_completed: 0,
			podcasts_published: 0,
			position_ranking: 0,
			position_ranking_general: 0,
			presentials_certified: 0,
			presentials_percentage_completed: 0,
			presentials_published: 0,
			qty_group_training_user_results: 0,
			qty_user_badges: 0,
			ranking_list: [],
			ranking_ordered: [],
			rankings: [],
			score: 0,
			selected_badge: {},
			show_all_badges: false,
			show_all_certificates: false,
			show_all_ranking: false,
			show_badge_details: false,
			show_certificate: false,
			show_statement: false,
			trails_certified: 0,
			trails_percentage_completed: 0,
			trails_published: 0,
			user_position: null,
			user_statement: [],
			webcasts_certified: 0,
			webcasts_percentage_completed: 0,
			webcasts_published: 0,
			clientModules: {
				has_courses: false,
				has_trails: false,
				has_presential: false,
				has_live_classes: false,
				has_podcasts: false,
				has_webcasts: false,
				has_drills: false,
			},
			networks: [
				{
					network: 'facebook',
					name: 'Facebook',
					icon: 'fab fah fa-lg fa-facebook-f',
					color: '#FFFFFF',
				},
				{
					network: 'linkedin',
					name: 'LinkedIn',
					icon: 'fab fah fa-lg fa-linkedin',
					color: '#007bb5',
				},
				{
					network: 'twitter',
					name: 'Twitter',
					icon: 'fab fah fa-lg fa-twitter',
					color: '#1da1f2',
				},
				{
					network: 'whatsapp',
					name: 'Whatsapp',
					icon: 'fab fah fa-lg fa-whatsapp',
					color: '#25d366',
				},
			],
		}
	},

	components: {
		certificate: Certificate,
		certificates: Certificates,
		ranking: Ranking,
		'score-statement': ScoreStatement,
	},

	computed: {
		...mapGetters({
			id: 'common/id',
			clients: 'params/clients',
			genders_store: 'site_lists/genders',
			id_user_client_selected: 'common/id_user_client_selected',
			marital_status_store: 'site_lists/marital_status',
			badge_id: 'notifications/badge_id',
			user_firebase_document: 'common/user_firebase_document',
			id_user_language_selected: 'common/id_user_language_selected',
		}),

		filteredRanking() {
			let ranking_ordered = []

			if (this.rankings?.users?.length) {
				ranking_ordered = this.rankings.users.sort((a, b) =>
					parseFloat(a.s) < parseFloat(b.s) ? 1 : parseFloat(b.s) < parseFloat(a.s) ? -1 : 0
				)

				let obj = ranking_ordered.find((obj) => obj.i === this.id)

				if (obj) {
					this.user_position = obj
					let pos = this.rankings.users.map((e) => e.i).indexOf(this.user_position.i)
					if (pos > 4) this.user_position.pos = pos
					else this.user_position = null
				} else this.user_position = null

				return ranking_ordered.map((e) => ({ ...e, image_error: false })).slice(0, 5)
			} else return []
		},

		filteredCertificates() {
			let certificates = Object.assign([], this.certificates)
			return certificates.splice(0, 6)
		},

		isMobile() {
			return this.$q.platform.is.mobile
		},

		progress_title() {
			const progress_title = []
			const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)

			if (obj) {
				if (obj.has_courses) {
					progress_title.push({
						to: 'courses',
						text: obj.title_trainings == '' ? 'online_courses' : obj.title_trainings,
					})
				}

				if (obj.has_trails) {
					progress_title.push({
						to: 'trails',
						text: obj.title_trails == '' ? 'trails' : obj.title_trails,
					})
				}

				if (obj.has_presential) {
					progress_title.push({
						to: 'presentials',
						text: obj.title_presential == '' ? 'presential_courses' : obj.title_presential,
					})
				}

				if (obj.has_webcasts) {
					progress_title.push({
						to: 'webinars',
						text: obj.title_webcasts == '' ? 'webinars' : obj.title_webcasts,
					})
				}

				if (obj.has_live_classes) {
					progress_title.push({
						to: 'live_classes',
						text: obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes,
					})
				}

				if (obj.has_podcasts) {
					progress_title.push({
						to: 'podcasts',
						text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts,
					})
				}
				if (obj.has_drills) {
					progress_title.push({
						to: 'drills',
						text: obj.title_drills == '' ? 'drills' : obj.title_drills,
					})
				}
			}

			return progress_title
		},

		hasBadges() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})
			return obj.has_badges ? obj.has_badges : false
		},
	},

	methods: {
		getAll() {
			this.loading = true
			this.$axios
				.all([this.getUserStatistics(), this.getUserStatisticsNew()])
				.then(
					this.$axios.spread((user_statistics, user_statistics_new, certificates) => {
						this.qty_user_badges = user_statistics_new.data.qty_user_badges
						this.qty_group_training_user_results =
							user_statistics_new.data.qty_group_training_user_results
						this.position_ranking = user_statistics_new.data.position_ranking
						this.position_ranking_general = user_statistics_new.data.position_ranking_general
						this.score = user_statistics_new.data.score

						this.online_percentage_completed = user_statistics.data.user_group_training_progress
							? parseInt(user_statistics.data.user_group_training_progress.toFixed(0))
							: 0
						this.online_published = user_statistics.data.qty_group_trainings_published || 0
						this.online_certified = user_statistics.data.qty_group_trainings_certified || 0

						this.trails_percentage_completed = user_statistics.data.user_trails_progress
							? parseInt(user_statistics.data.user_trails_progress.toFixed(0))
							: 0
						this.trails_published = user_statistics.data.qty_trails_published || 0
						this.trails_certified = user_statistics.data.qty_trails_certified || 0

						this.presentials_percentage_completed = user_statistics.data.user_presential_progress
							? parseInt(user_statistics.data.user_presential_progress.toFixed(0))
							: 0
						this.presentials_published = user_statistics.data.qty_presential_published || 0
						this.presentials_certified = user_statistics.data.qty_presential_certified || 0

						this.live_classes_percentage_completed = user_statistics.data.user_live_classes_progress
							? parseInt(user_statistics.data.user_live_classes_progress.toFixed(0))
							: 0
						this.live_classes_published = user_statistics.data.qty_live_classes_published || 0
						this.live_classes_certified = user_statistics.data.qty_live_classes_certified || 0

						this.webcasts_percentage_completed = user_statistics.data.user_webcasts_progress
							? parseInt(user_statistics.data.user_webcasts_progress.toFixed(0))
							: 0
						this.webcasts_published = user_statistics.data.qty_webcasts_published || 0
						this.webcasts_certified = user_statistics.data.qty_webcasts_certified || 0

						this.podcasts_percentage_completed = user_statistics.data.user_podcasts_progress
							? parseInt(user_statistics.data.user_podcasts_progress.toFixed(0))
							: 0
						this.podcasts_published = user_statistics.data.qty_podcasts_published || 0
						this.podcasts_certified = user_statistics.data.qty_podcasts_certified || 0

						this.badges = user_statistics.data.user_badges.map((e) => {
							let obj = e.badge_languages.find(
								(obj) => this.id_user_language_selected == obj.language
							)
							return {
								badge_images: e.badge_images.length ? e.badge_images : [],
								badge_languages: e.badge_languages,
								badge_image_alt_texts: e.badge_image_alt_texts?.length
									? e.badge_image_alt_texts[0].alt_text
									: '',
								description: obj ? obj.description : e.description,
								earned_date: e.earned_date,
								id: e.id,
								slug: e.slug,
								title: obj ? obj.title : e.title,
								shared_url: process.env.SITE_URL + `/media_public/badges/${e.id}${this.id}.jpg`,
							}
						})

						this.user_statement = user_statistics.data.user_score_statement
						this.ranking_list = user_statistics.data.user_firebase_document_ranking_areas.map(
							(e) => ({ ...e, label: e.area, value: e.document })
						)
						this.ranking_list.unshift({ label: this.$t('general'), value: 'all' })

						if (this.badge_id) {
							let badge = this.badges.find((obj) => {
								return obj.id === this.badge_id
							})
							if (badge) this.showBadgeDetails(badge)
							this.$store.dispatch('notifications/SET_BADGE_ID', [null])
						}
						this.getCertificates()
					})
				)
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
					if (this.$route.query.type) this.homeRedirected(this.$route.query.type)
				})
		},

		homeRedirected(expr) {
			switch (expr) {
				case 'ranking':
					this.show_all_ranking = true
					break
				case 'point':
					this.show_statement = true
					break
				case 'badges':
					this.show_all_badges = true
					break
				case 'certificate':
					this.showAllCertificates()
					break
			}
		},

		getUserStatistics() {
			return this.$axios.get(`/etraining_profile/my_profile/get_user_statistics/`)
		},

		getUserStatisticsNew() {
			return this.$axios.get(`etraining_profile/my_profile/user_statistics/`)
		},

		async getCertificates() {
			try {
				if (this.show_all_certificates) {
					this.loading = true
					this.$q.loading.show()
				}

				const certificates = await this.$axios.get(
					`etraining_profile/my_profile/user_results/${
						!this.show_all_certificates ? '?is_index=True' : ''
					}`
				)

				this.certificates = []
					.concat(
						certificates.data.group_trainings.map((e) => ({
							...e,
							origin: 'group_trainings',
							images: e.group_training_images.map((f) => ({ ...f, image: f.image_url })),
							title: e.group_training_title,
						})),
						certificates.data.live_classes.map((e) => ({
							...e,
							origin: 'live_classes',
							images: e.live_class_images,
							title: e.live_class_title,
						})),
						certificates.data.presential_events.map((e) => ({
							...e,
							origin: 'presential_events',
							images: e.presential_event_images,
							title: e.presential_event_title,
						})),
						certificates.data.webcasts.map((e) => ({
							...e,
							origin: 'webcasts',
							images: e.webcast_images,
							title: e.webcast_title,
						}))
					)
					.sort((a, b) => new Date(a.result_date) - new Date(b.result_date))
					.reverse()
			} catch (error) {
				console.log(error)
				this.showLoadingErrorMessage()
			} finally {
				if (this.loading) {
					this.loading = false
					this.$q.loading.hide()
				}
			}
		},

		async showCertificate(certificate) {
			this.$q.loading.show()
			try {
				let url
				switch (certificate.origin) {
					case 'group_trainings':
						url = `/etraining_courses/group_training/${certificate.group_training_id}/get_group_training_user_result_certificate/`
						break
					case 'live_classes':
						url = `/etraining_live_classes/live_classes/${certificate.live_class_id}/certificate/`
						break
					case 'presential_events':
						url = `/etraining_presential/presential/${certificate.presential_event_id}/get_presential_event_user_result_certificate/`
						break
					case 'webcasts':
						url = `/etraining_webcasts/webcasts/${certificate.webcast_id}/get_webcast_user_result_certificate/`
						break
					case 'trails':
						url = `etraining_trails/trails/${certificate.trail_id}/get_trail_user_result_certificate/`
						break
				}

				let fd = new FormData()
				fd.append('user_id', this.id)
				fd.append('result_id', certificate.id)
				const response = await this.$axios.post(url, fd)

				this.course = certificate
				this.certificate = response.data
				this.show_certificate = true
			} catch (e) {
				console.log(e)
				this.showLoadingErrorMessage()
			} finally {
				this.$q.loading.hide()
			}
		},

		showLoadingErrorMessage() {
			this.$q.notify({
				message: this.$t('an_unexpected_error_has_occurred_try_again'),
				type: 'negative',
				icon: 'fal fa-exclamation-triangle',
				position: 'bottom',
			})
			return
		},

		badgeImage(images) {
			if (images.length) return images.find((e) => e.image_name === '250x250').image
			else return ''
		},

		certificateImage(obj) {
			const image = obj.images.find((e) => e.name === 'original')

			let client = this.clients.find((clt) => clt.id == this.id_user_client_selected)

			if (image.image_url || image.image) {
				if (image.image_url) return image.image_url
				else if (image.image) return image.image
			} else {
				if (obj.origin === 'group_trainings') return client.group_training_placeholder
				else return client.webcast_placeholder
			}
		},

		getImage(ranking) {
			return `${process.env.BUCKET_URL}media/users/${ranking.i}/images/50x50.jpg`
		},

		getScore(score) {
			let client = this.clients.find((obj) => obj.id === this.id_user_client_selected)

			if (client && client.ranking_use_decimal) return score.toFixed(2)
			else return score.toFixed(0)
		},

		showBadgeDetails(badge) {
			this.selected_badge = badge
			this.show_all_badges = true
			this.show_badge_details = true
		},

		showAllCertificates() {
			this.show_all_certificates = true
			this.getCertificates()
		},

		checkClientModules() {
			const client = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			if (client) {
				for (const [key, value] of Object.entries(this.clientModules)) {
					if (client[key] !== undefined) {
						this.clientModules[key] = client[key]
					}
				}
			} else return
		},

		removeUserEmail(name) {
			return name.indexOf('(') !== -1 ? name.slice(0, name.indexOf('(')) : name
		},

		redirectTo(name) {
			this.$store.dispatch(`${name}/SET_PROGRESS`, 'finished')
			this.$router.push({ name: name })
		},
	},

	watch: {
		user_firebase_document: {
			handler: function (newValue) {
				this.user_position = null
				this.rankings = []

				if (this.user_firebase_document) {
					getAuth()
					onSnapshot(doc(db, 'ranking', `${this.user_firebase_document}`), (doc) => {
						this.rankings = doc.data()
					})
				}
			},
			deep: true,
		},

		badge_id: function () {
			if (this.badge_id) {
				let badge = this.badges.find((obj) => obj.id === this.badge_id)
				if (badge) this.showBadgeDetails(badge)
				this.$store.dispatch('notifications/SET_BADGE_ID', [null])
			}
		},
	},

	created() {
		this.getAll()
		this.checkClientModules()

		if (this.user_firebase_document) {
			getAuth()
			onSnapshot(doc(db, 'ranking', `${this.user_firebase_document}`), (doc) => {
				this.rankings = doc.data()
			})
		}
	},

	mounted() {
		this.icon_x_twitter = IconXTwitter
	},
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 1.7rem;
}
.subtitle-points {
	font-size: 1rem;
}
.disabled-badge {
	filter: grayscale(100%);
}
.cards-mobile {
	min-height: 250px;
}
.cards-desktop {
	min-height: 300px;
}
.user-name {
	line-height: 1rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.text-ranking {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
